import { MDBAlert } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { createCustomFieldCont, updateCustomFieldCont } from '../../../apiclients/streamsapi_bridge';
import { useNavigate } from 'react-router';

const CreateEditCutomField = forwardRef(({ onClose, setIsloading, customInfo, editFlag }, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, watch, formState: { isDirty, dirtyFields, errors }, setError, reset, clearErrors } = useForm({
        defaultValues: {
            label: "",
            field_type: 1,

        }
    });

    useEffect(() => {
        if (editFlag && Object.keys(customInfo).length > 0) {
            reset({
                label: customInfo?.label ?? "",
                field_type: customInfo?.field_type ?? 1,
            });

        }

    }, [customInfo]);

    const onsubmit = async (data) => {
        let updates = {};
        let saverep = {};
        if (editFlag) {
            if (dirtyFields) {
                let modifiedData = extractModifiedFields(dirtyFields, data);
                if (modifiedData) {
                    modifiedData.reqid = 104;
                    modifiedData.siteid = JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid;
                    modifiedData.field_id = String(customInfo.field_id);
                    setIsloading(true);
                    console.log("JSON update custom field:: " + JSON.stringify(updates));
                    saverep = await updateCustomFieldCont(modifiedData);
                }

            }
        } else {
            if (isDirty) {
                updates = {
                    reqid: 103,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                    label: data.label,
                    field_type: String(data.field_type),
                };
            }
            //alert(JSON.stringify(updates))
            console.log("JSON Create custom field:: " + JSON.stringify(updates));
            setIsloading(true);
            saverep = await createCustomFieldCont(updates);
        }
        console.log(`reponse of Create Edit custom field :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(`reponse of Create Edit custom field after:::: ${JSON.stringify(saverepeMsg)}`);
        setTimeout(() => {
            setIsloading(false);
        }, 2000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            onClose();
            navigate("/contactslanding", {
                state: { tab: "tab3" },
            });
            window.location.reload();

        } else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();

                    }
                });
            }

        }
    }

    function extractModifiedFields(dirtyFields, data) {
        const modifiedData = {};

        function recurse(dirtyFields, data, modifiedData) {
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        modifiedData[field] = {};
                        recurse(dirtyFields[field], data[field], modifiedData[field]);
                    } else {
                        modifiedData[field] = data[field];
                    }
                }
            }
        }

        recurse(dirtyFields, data, modifiedData);
        return modifiedData;
    }

    return (
        <>
            <div className="tel-numbers mt-2">
                <strong>Field Name</strong>
            </div>
            <div className="form pt-1 w-100">
                <input maxLength={30} type="text" {...register("label", { required: "Field Name is required" })} className="w-100 form-control" />
                {errors.label && (
                    <p className="text-danger">{errors.label.message}</p>
                )}
            </div>
            <div className="tel-numbers mt-2">
                <strong>Field Type</strong>
            </div>
            <div className="form pt-1 w-100">

                <select
                    className="form-control form-select selectname w-100"
                    name="San Jose"
                    {...register("field_type")}
                >
                    <option value={1}>
                        Text Box
                    </option>
                    <option value={2}>
                        Text Area
                    </option>
                </select>
                {errors.field_type && (
                    <p className="text-danger">{errors.field_type.message}</p>
                )}
            </div>
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                    {t("add")}</button>
            </div>

            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}

        </>
    )
});

export default CreateEditCutomField
